import { render, staticRenderFns } from "./Rp.vue?vue&type=template&id=b28bf7b8&scoped=true"
import script from "./Rp.vue?vue&type=script&lang=js"
export * from "./Rp.vue?vue&type=script&lang=js"
import style0 from "./Rp.vue?vue&type=style&index=0&id=b28bf7b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28bf7b8",
  null
  
)

export default component.exports